module.exports = __webpack_public_path__ + "static/media/invo-button-mobile.b3aca0b3.svg";